import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from '@wix/document-services-types';

export function getSectionLikeAttachCandidateOnUnpin(
  editorAPI: EditorAPI,
  ref: CompRef,
) {
  const { y, height } =
    editorAPI.components.layout.getRelativeToStructure_rect(ref);
  const compMiddleY = y + height / 2;
  const containerRef = editorAPI.sections.getSectionLikeAtY(compMiddleY);

  if (!containerRef) {
    throw new Error(`Section like component not found at y: ${compMiddleY}`);
  }

  return containerRef;
}
